import { lighten } from '@mui/material/styles';

// export const PrimaryThemeColor = '#238cb9';
export const PrimaryThemeColor = '#1976D2';
export const PrimaryThemeColorLight = lighten(PrimaryThemeColor, 0.9);
export const ShGreen = '#74C05A';
// export const BorderColorLight = '#EBEFF2';
// export const BorderColorLight = '#0000001f';
export const BorderColorLight = '#ebebeb';
export const BorderColorDark = '#474748';
export const TextPrimary = '#111111';
export const DarkModeBackground = '#2B2B2B';
export const LightModeBackground = '#FFFFFF';
export const WhiteColor = '#FFFFFF';
export const LogoutRedColor = '#F7685B';
export const MUIGrey = '#6d6d6d';
export const PaperBorderRadius = '4px';
export const ShBorderRadius = '4px';
export const ShIconPrimary = '#1976D2';
export const ShIconSecondary = '#2196F3';
// test/demo colors
// export const ShIconPrimary = '#74C059';
// export const ShIconSecondary = '#A7CC46';

export const PaperElevation = 1;
export const PaperVariant: 'elevation' | 'outlined' = 'outlined';
export const ShGreenLightGradient = 'linear-gradient(to bottom, #ffffff, #fcfdff, #f7fdff, #f2fcfd, #effbf7, #effbf7, #effbf7, #effbf7, #f2fcfd, #f7fdff, #fcfdff, #ffffff)';
